/**
 * cardButton.tsx
 */
import Container from '../../../atoms/container/cardButtonContainer';
import InfoIcon from '../../../atoms/icons/cardInfoIcon';
import PlanIcon from '../../../atoms/icons/cardPlanIcon';
import PlayIcon from '../../../atoms/icons/cardPlayIcon';
import { CardButtonIcon } from '@shared/types/enums/card';

/**
 * Props for the CardButton component.
 */
interface Props {
  color?: string;
  focused?: boolean;
  iconType?: CardButtonIcon;
}

/**
 * CardButton component.
 */
export default function CardButton({
  color,
  focused = false,
  iconType,
}: Props) {
  let Icon = null;

  switch (iconType) {
    case CardButtonIcon.INFO:
      Icon = InfoIcon;
      break;
    case CardButtonIcon.PLAN:
      Icon = PlanIcon;
      break;
    case CardButtonIcon.PLAY:
      Icon = PlayIcon;
      break;
  }

  return (
    <Container active={focused} color={color}>
      {Icon ? <Icon focused={focused} /> : null}
    </Container>
  );
}
